import styled from 'styled-components';
import { palette } from 'styled-theme';
import { device } from '@jjj/components';
import WithDirection from '../../settings/withDirection';

const AppHolder = styled.div`
  .currentDate {
    background: ${palette('grayscale', 4)};
    color: ${palette('grayscale', 1)};
    font-size: 12px;
    margin-bottom: -3px;
    padding: ${props => (props['data-rtl'] === 'rtl' ? '60px 20px 0 0' : '60px 0 0 20px')};
  }

  .empty-div {
    padding: 20px;
  }

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 16px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: ${palette('primary', 0)};
  }

  .ant-layout-sider-collapsed .anticon {
    font-size: 16px;
  }

  .ant-layout-sider-collapsed .nav-text {
    display: none;
  }

  .ant-layout {
    background: ${palette('grayscale', 6)};

    &.isoContentMainLayout {
      overflow: auto;
      overflow-x: hidden;
      width: 100%;
      flex-shrink: 0;

      @media ${device.tablet} {
        width: calc(100% - 80px);
        flex-shrink: 0;
      }

      @media ${device.laptop} {
        width: calc(100% - 240px);
      }

      .ant-breadcrumb {
        &.fake {
          min-height: 22px;
          padding: 92px 20px 0px;
          position: relative;
        }
      }
    }
  }

  .isoLayoutContent {
    width: 100%;
    padding: 35px;
    background-color: ${palette('background', 0)};
    border: 1px solid ${palette('border', 0)};
    height: 100%;
  }

  .ant-tabs-top > .ant-tabs-nav {
    margin-bottom: 0;
    border-top: 1px solid ${palette('grayscale', 3)};
    border-right: 1px solid ${palette('grayscale', 3)};
    border-left: 1px solid ${palette('grayscale', 3)};
  }

  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap {
    padding-left: 30px;
  }

  .ant-tabs-nav-list {
    .ant-tabs-tab.ant-tabs-tab-active {
      .ant-tabs-tab-btn {
        color: ${palette('grayscale', 0)};
      }
    }
  }

  .ant-tabs.ant-tabs-card > .ant-tabs-bar {
    .ant-tabs-tab {
      padding: 0 60px 1px;
      color: ${palette('grayscale', 1)};
    }

    .ant-tabs-tab-active {
      color: ${palette('grayscale', 0)};
    }
  }

  .ant-tabs.ant-tabs-card > .ant-tabs-bar .ant-tabs-tab:not(.ant-tabs-tab-active) {
    background: ${palette('grayscale', 4)};
    padding: 0 60px;
    border: none;
  }

  .isomorphicSidebar {
    background: ${palette('grayscale', 5)};

    .isoLogoWrapper {
      background: ${palette('grayscale', 5)};
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .ant-menu-submenu {
      .ant-menu-item {
        border-color: rgba(0, 0, 0, 0.3);
      }

      .ant-menu-item-selected {
        background-color: ${palette('grayscale', 4)};
        border-left: 4px solid ${palette('info', 0)};
      }
    }

    .ant-menu-item {
      border-left: 4px solid ${palette('grayscale', 5)};
    }

    .ant-menu-sub {
      .ant-menu-item {
        border-left: none;

        &:hover {
          border-left: none;
        }
      }
    }

    .ant-menu-item-selected {
      border-left: 4px solid ${palette('primary', 0)};
    }
  }

  .isomorphicLayout {
    width: 100%;
    flex-shrink: 0;
    overflow-x: hidden !important;

    @media ${device.tablet} {
      width: calc(100% - 80px);
    }

    @media ${device.laptop} {
      width: calc(100% - 240px);
    }
  }

  .ant-layout-footer {
    font-size: 13px;
    padding: 10px 20px;

    @media ${device.tablet} {
      padding-left: 30px;
      padding-right: 30px;
    }

    .link-container:not(:first-child) {
      margin-left: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '20px')};
      margin-right: ${props => (props['data-rtl'] === 'rtl' ? '20px' : 'auto')};
    }
  }

  .ant-legacy-form-explain {
    font-size: 12px;
    margin-top: 3px;
  }

  .has-error {
    .inputLabel {
      color: ${palette('grayscale', 1)};
    }

    .inputNumberLabel {
      color: ${palette('error', 0)};
    }

    .ant-legacy-form-explain {
      color: ${palette('error', 0)};
      font-weight: normal;
    }

    .ant-input,
    .ant-input:focus,
    .ant-select,
    .ant-select .ant-select-selection,
    .form-group input {
      background-color: ${palette('error', 2)} !important;
      box-shadow: none !important;
    }
  }

  .action-icon,
  .cross-icon,
  .edit-icon {
    height: 19px;
    margin-left: 5px;
    margin-right: 6px;
    width: 20px;
  }

  .edit-icon {
    height: 30px;
    color: ${palette('success', 0)};
  }

  .cross-icon {
    color: ${palette('error', 0)};
  }

  .applicant-record-button {
    margin: -1px 0;
    font-size: 16;
    font-weight: 900;
    padding: 0 20px;
  }

  .ant-btn {
    margin: 5px;
  }
`;

export default WithDirection(AppHolder);
